@import "../../variables.scss";

.personalDeclaration__image {
  position: absolute;
  right: 50px;
  bottom: -431px;
}

.personalDeclaration__imageBackground {
  position: relative;
  @media (max-width: 991px) {
    margin-bottom: 30px;
    padding: 0;
  }
}

.personalDeclaration__imageBackground:after {
  content: "";
  width: 2032px;
  height: 1296px;
  background-color: $color-background-blue;
  position: absolute;
  left: -270%;
  top: -754px;
  border-radius: 50%;

  @media (max-width: 1200px) {
    left: -335%;
  }
  @media (max-width: 991px) {
    left: -44%;
    top: -75%;
    width: 200%;
    height: 193%;
  }
}

.personalDeclaration {
  &__declaration {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-left: 80px !important;

    @media (max-width: 991px) {
      padding: 0 !important;
    }

    @media (min-width: 992px) {
      height: 550px;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 5px;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
      }

      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #555;
        border-radius: 10px;
      }
    }
  }

  &__buttonContainer {
    display: flex;
    justify-content: flex-end;
    width: 100%;

    button,
    a {
      width: 140px;

      &:hover {
        text-decoration: none;
      }
    }
  }
}